export const WS_STATUS = {
  INIT: 'INIT',
  OPENING: 'OPENING',
  OPEN: 'OPEN',
  CLOSING: 'CLOSING',
  CLOSED: 'CLOSED',
  OPEN_ERROR: 'OPEN_ERROR',
  OPEN_TIMEOUT: 'OPEN_TIMEOUT',
  HEARTBEAT_TIMEOUT: 'HEARTBEAT_TIMEOUT',
  ERROR: 'ERROR',
};

export const IP_RESTRICTED_CODE = {
  RESTRICTED: 31043,
  WARNING: 31046,
  REGISTER_FORBIDDEN: 31029,
};
